/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, ReactElement, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as Menu } from '../../assets/icons/menu.svg'
import logo from '../../assets/logo.svg'
import Button from '../button'
import { Container, Inside, Nav } from './styles'

type NavElement = {
  name: string,
  to?: string,
  href?: string,
  type?: 'button' | 'link'
}

type SeparatorElement = {
  separate: boolean
}

export type NavBarProps = {
  children?: ReactElement,
  variant?: 'primary' | 'secondary'
  navigation?: (NavElement | SeparatorElement)[]
}

const NavBar: FC<NavBarProps> = ({ navigation, variant }): ReactElement => {
  const [isVisible, setVisibility] = useState(false)

  useMemo(() => {
    const clickEvent = (e: any) => {
      if (e.target.closest('.menu') === null) {
        if (isVisible) setVisibility(false)
      }
    }

    document.addEventListener('click', clickEvent)

    return () => document.removeEventListener('click', clickEvent)
  }, [isVisible])

  return (
    <Container variant={variant}>
      <Inside>
        <button
          type='button'
          className='menu'
          onClick={() => setVisibility(true)}
        >
          <Menu />
        </button>
        <a className='logo' href='/'>
          <img src={logo} alt='logo' />
        </a>
        {navigation && (
          <Nav id='navigation' $isVisible={isVisible}>
            <ul>
              {navigation.map((nav, i) => {
                if ((nav as SeparatorElement).separate) {
                  return <li key={`separator-${i}`} className='separator' />
                } else {
                  const navEl = nav as NavElement
                  return (
                    <li key={navEl.href || navEl.to}>
                      {navEl.type !== 'button' && navEl.href && <a target='_blank' href={navEl.href} rel='noreferrer'>{navEl.name}</a>}
                      {navEl.type !== 'button' && navEl.to && <Link to={navEl.to}>{navEl.name}</Link>}
                      {navEl.type === 'button' && <Button href={navEl.href} to={navEl.to}>{navEl.name}</Button>}
                    </li>
                  )
                }
              })}
            </ul>
          </Nav>
        )}
      </Inside>
    </Container>
  )
}

NavBar.defaultProps = {
  variant: 'primary'
}

export default NavBar
